import { render, staticRenderFns } from "./RefreshApp.vue?vue&type=template&id=2fd18601&scoped=true&"
import script from "./RefreshApp.vue?vue&type=script&lang=ts&"
export * from "./RefreshApp.vue?vue&type=script&lang=ts&"
import style0 from "./RefreshApp.vue?vue&type=style&index=0&id=2fd18601&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd18601",
  null
  
)

export default component.exports